// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@conklin/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

viewStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, auto) 376px;
        gap: 20px 22px;
        ${xScreen("lte", "lg")} {
            grid-template-columns: minmax(0, auto) 317px;
        }
        ${xScreen("lte", "md")} {
            display: flex;
            flex-wrap: wrap;
            column-gap: 20px;
        }
        ${xScreen("lte", 767)} {
            display: flex;
            flex-wrap: wrap;
        }
        @media print {
            display: block;
        }
    `,
};
viewStyles.leftSection = {
    css: css`
        ${xScreen("lte", "md")} {
            flex-grow: 1;
            max-width: calc(100% - 252px); // 232 + 20 gap
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            max-width: unset;
        }
        @media print {
            width: 100%;
        }
    `,
};
viewStyles.rightSection = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 232px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
        @media print {
            width: 100%;
        }
    `,
};
viewStyles.leftTopPart = {
    css: css`
        display: grid;
        grid-template-columns: 508px auto;
        gap: 22px;
        width: 100%;
        ${xScreen("lte", "lg")} {
            grid-template-columns: 430px auto;
        }
        ${xScreen("lte", "md")} {
            display: flex;
            flex-wrap: wrap;
            margin-top: 12px;
        }

        @media print {
            display: block;
            margin-top: 12px;
        }
    `,
};

viewStyles.separator = {
    css: css`
        width: 100%;
        height: 1px;
        margin: 24px auto;
        ${xScreen("lte", 767)} {
            display: none;
        }
        @media print {
            margin: 8px auto;
            border: none;
        }
    `,
};
viewStyles.divider = {
    css: css`
        width: 100%;
        height: 1px;
        border-top: 1px solid ${color("common.border")};
        margin: 12px auto;
    `,
};

viewStyles.imageSection = {
    css: css`
        width: 100%;
        & > div {
            display: flex;
            column-gap: 20px;
            row-gap: 12px;
            @media print {
                display: flex !important;
            }
            ${xScreen("lte", "md")} {
                flex-direction: column;
                & > div:last-child {
                    order: -1;
                }
            }
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};

viewStyles.descriptionAndDocuments = {
    css: css`
        ${xScreen("lte", "md")} {
            & > div {
                padding-bottom: 48px;
                &:empty {
                    border-bottom: 0;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
            }
        }
    `,
};

viewStyles.productNumbersWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 4px;
    `,
};

viewStyles.actionsBox = {
    container: {
        css: css`
            border-radius: 4px;
            @media print {
                border: none;
                padding: 12px 0 0;
            }
        `,
    },
};

viewStyles.bottomSection = {
    css: css`
        width: 100%;
    `,
};

viewStyles.additionalContent = {
    css: css`
        &:has(.carousel-main-wrapper) {
            border-top: 1px solid ${color("common.border")};
            padding-top: 24px;

            > div:first-of-type {
                border-bottom: 1px solid ${color("common.border")};
                margin-bottom: 48px;
            }
        }
    `,
};
